var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("loader")
        : _c(
            "form",
            {
              ref: "form",
              attrs: { id: "notifications-form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.handleSubmit.apply(null, arguments)
                },
                change: _vm.handleFormChange,
              },
            },
            _vm._l(_vm.notifications, function (actions, name, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "card",
                  class: {
                    "d-none": !_vm.sectionVisibilityMap[name][_vm.source],
                  },
                },
                [
                  _vm.sectionVisibilityMap[name][_vm.source]
                    ? _c("ul", { staticClass: "list-group list-group-flush" }, [
                        _c("li", { staticClass: "list-group-item" }, [
                          _c("div", { staticClass: "row align-items-center" }, [
                            _c(
                              "div",
                              { staticClass: "col-sm col-12 mb-sm-0 mb-2" },
                              [
                                _c(
                                  "h6",
                                  {
                                    staticClass: "grey-text text-darken-3 m-0",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getSectionTitle(name)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-auto" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-jelly p-smooth p-curve left-all-box",
                                },
                                [
                                  _c("input", {
                                    staticClass: "checkbox",
                                    attrs: {
                                      id: _vm.getInputName(name, "email-all"),
                                      name: _vm.getInputName(name, "email-all"),
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: _vm.shouldBeMarkedFor(
                                        name,
                                        "email"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.markAllInside(
                                          $event,
                                          name,
                                          "email"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "state p-success" },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-check",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "clickable",
                                          attrs: {
                                            for: _vm.getInputName(
                                              name,
                                              "email-all"
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$tc("global.words.all", 1)
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.hideAllWeb
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-jelly p-smooth p-curve right-all-box",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "checkbox",
                                        attrs: {
                                          id: _vm.getInputName(name, "web-all"),
                                          name: _vm.getInputName(
                                            name,
                                            "web-all"
                                          ),
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: _vm.shouldBeMarkedFor(
                                            name,
                                            "web"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.markAllInside(
                                              $event,
                                              name,
                                              "web"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-success" },
                                        [
                                          _c("i", {
                                            staticClass: "icon fa fa-check",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "clickable",
                                              attrs: {
                                                for: _vm.getInputName(
                                                  name,
                                                  "web-all"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$tc(
                                                      "global.words.all",
                                                      1
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "list-group-item" },
                          _vm._l(actions, function (action, actionName) {
                            return _c(
                              "div",
                              {
                                key: actionName,
                                staticClass:
                                  "row align-items-center separator-bottom mb-3 pb-2 notification-settings-row",
                              },
                              [
                                !_vm.actionHideMap[actionName] ||
                                !_vm.actionHideMap[actionName][_vm.source]
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm col-12 mb-sm-0 mb-2",
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "mb-0 small text-gray text-uppercase",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getActionTitle(
                                                      actionName
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 small text-gray",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getActionDescription(
                                                      actionName
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-auto" }, [
                                        action.emailSupported !== false
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pretty p-icon p-jelly p-smooth p-curve left-all-box",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: action.email,
                                                      expression:
                                                        "action.email",
                                                    },
                                                  ],
                                                  staticClass: "checkbox",
                                                  attrs: {
                                                    id: _vm.getInputName(
                                                      actionName,
                                                      "email"
                                                    ),
                                                    name: _vm.getInputName(
                                                      actionName,
                                                      "email"
                                                    ),
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      action.email
                                                    )
                                                      ? _vm._i(
                                                          action.email,
                                                          null
                                                        ) > -1
                                                      : action.email,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a = action.email,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              action,
                                                              "email",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              action,
                                                              "email",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          action,
                                                          "email",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "state p-success",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon fa fa-check",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "clickable text-capitalize",
                                                        attrs: {
                                                          for: _vm.getInputName(
                                                            actionName,
                                                            "email"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$tc(
                                                                "global.words.email",
                                                                1
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.hideAllWeb
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pretty p-icon p-jelly p-smooth p-curve right-all-box",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: action.web,
                                                      expression: "action.web",
                                                    },
                                                  ],
                                                  staticClass: "checkbox",
                                                  attrs: {
                                                    id: _vm.getInputName(
                                                      actionName,
                                                      "web"
                                                    ),
                                                    name: _vm.getInputName(
                                                      actionName,
                                                      "web"
                                                    ),
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      action.web
                                                    )
                                                      ? _vm._i(
                                                          action.web,
                                                          null
                                                        ) > -1
                                                      : action.web,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a = action.web,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              action,
                                                              "web",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              action,
                                                              "web",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          action,
                                                          "web",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "state p-success",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon fa fa-check",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "clickable",
                                                        attrs: {
                                                          for: _vm.getInputName(
                                                            actionName,
                                                            "web"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "settings.notificationsTab.web"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }